import { render, staticRenderFns } from "./GestaoTerminal.vue?vue&type=template&id=0da5f622"
import script from "./GestaoTerminal.vue?vue&type=script&lang=js"
export * from "./GestaoTerminal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports